import { defineStore } from 'pinia'

// 읽기 전용 모드 상태 관리 스토어
export const useIsReadonlyStore = defineStore('isReadonly', () => {
  //default는 파라미터에서 찾아와서 검사
  const urlParams = new URLSearchParams(window.location.search)
  const isReadonly = urlParams.get('readonly')

  return {
    isReadonly
  }
})
